
    import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
    import { mapActions, mapState } from 'vuex';
    import moment from 'moment';
    import { VMenu } from '@/types/Components';
    import { ImpfauswertungenOptions } from '@/store/statistik';

    @Component({
        computed: {
            ...mapState('statistik', ['loaders']),
            ...mapState('globals', ['rules']),

        },
        methods: {
            ...mapActions('statistik', ['printImpfauswertung']),
        },
    })
    export default class Impfauswertung extends Vue {
        @Prop() public visible!: boolean;

        public $refs!: {
            zeitraumMenu: VMenu;
        };

        public printImpfauswertung!: (payload: { options: ImpfauswertungenOptions }) => void;

        public zeitraumMenu = false;

        public options: ImpfauswertungenOptions = {
            zeitraum: [
                moment().subtract(30, 'days').format('YYYY-MM-DD'),
                moment().format('YYYY-MM-DD'),
            ],
            variante: 'impfungen',
            sortierung: 'impfung',
            sortierreihenfolge: 'aufsteigend',
        };

        public get canPrint(): boolean {
            return this.options.zeitraum.length === 2;
        }

        public get maxZeitraum(): string {
            return moment().format('YYYY-MM-DD');
        }

        public get maxJahrgang(): number {
            return moment().year();
        }

        public get zeitraumLabel(): string {
            return this.options.zeitraum.length
                ? 'von ' + this.options.zeitraum.sort((a, b) => a.localeCompare(b)).map((date) => {
                    const [year, month, day] = date.split('-');
                    return `${day}.${month}.${year}`;
                }).join(' bis ')
                : '';
        }

        @Watch('zeitraum')
        public onChangeZeitraum(dates: [string, string]): void {
            if (dates?.length === 2) {
                this.options.zeitraum = dates;
            }
        }

        public saveZeitraum(date: [string, string]): void {
            this.options.zeitraum = date;
            this.$refs.zeitraumMenu.save(date);
        }

        public onClickPrint(): void {
            const options = {
                ...this.options,
                zeitraum: this.options.zeitraum.sort((a, b) => a.localeCompare(b)),
            };

            this.printImpfauswertung({ options });
        }

        public get getTitle() {
            if (this.options.variante === 'impfungen_je_arzt') {
                return 'Impfstatistik je Arzt';
            } else if (this.options.variante === 'impfstoffe') {
                return 'Impfstoffstatistik';
            } else if (this.options.variante === 'impfstoffe_je_arzt') {
                return 'Impfstoffstatistik je Arzt';
            } else if (this.options.variante === 'impfstoffe_je_patientengruppe') {
                return 'Impfstoffstatistik je Patientengruppe';
            } else if (this.options.variante === 'impfungen_ohne_preis') {
                return 'Impfstatistik ohne Beträge';
            } else return 'Impfstatistik';
        }
    }
